export const formatCurrency = (value: string | number | null | undefined): string => {
  if (value == null) return "N/A"
  const num = typeof value === "string" ? parseFloat(value) : value
  if (isNaN(num)) return "N/A"
  return `£${Math.round(num).toLocaleString("en-GB")}`
}

export const formatRoi = (value: number | null | undefined): string => {
  if (value == null) return "N/A"
  return `${value.toFixed(1)}%`
}

export const formatPayback = (years: number | null | undefined): string => {
  if (years == null) return "N/A"
  return `${years.toFixed(1)} yrs`
}

export const getRoiColor = (roi: number | null | undefined): string => {
  if (roi == null) return "gray.800"
  if (roi >= 8) return "green.600"
  if (roi >= 4) return "orange.500"
  return "gray.800"
}
